<template>
	<div v-if="data" class="no-print">
		<div
			:class="{ 'disabled' : loading }"
			class="btn-toolbar m-b-20" role="toolbar">

			<div class="btn-group">
				<router-link :to="goTo('')" class="btn btn-default btn-lg">
					<i class="fa fa-address-card-o" aria-hidden="true"></i>
					Cliente {{ $platform.setting.number_symbol }}{{ data.id }}
				</router-link>

				<button type="button" class="btn btn-default btn-lg dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					<span class="caret"></span>
					<span class="sr-only">Toggle Dropdown</span>
				</button>

				<ul class="dropdown-menu">
					<li>
						<router-link :to="goTo('edit')">
							<i class="fa fa-pencil-square-o"></i> Editar
						</router-link>
					</li>
				</ul>
			</div>

			<div class="btn-group">
				<router-link :to="goTo('billings')" class="btn btn-lg btn-default">
					<i class="fa fa-file-text-o" aria-hidden="true"></i>
					Datos facturación
					<span v-if="data.info">
						<span v-if="data.info.billings" class="badge">{{ data.info.billings }}</span>
					</span>
				</router-link>
			</div>

			<div class="btn-group">
				<router-link :to="goTo('budgets')" class="btn btn-default btn-lg">
					<i aria-hidden="true" class="fa fa-clipboard fa-fw"></i>
					Presupuestos
					<span v-if="data.info">
						<span v-if="data.info.budgets" class="badge">{{ data.info.budgets }}</span>
					</span>
				</router-link>

				<button type="button" class="btn btn-default btn-lg dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					<span class="caret"></span>
					<span class="sr-only">Toggle Dropdown</span>
				</button>

				<ul class="dropdown-menu">
					<li @click="addBudget">
						<a href="javascript:void(0)">
							<i class="fa fa-plus" aria-hidden="true"></i>
							Añadir
						</a>
					</li>
				</ul>
			</div>

			<div class="btn-group">
				<router-link :to="goTo('orders')" class="btn btn-default btn-lg">
					<i class="fa fa-file-text" aria-hidden="true"></i>
					Pedidos
					<span v-if="data.info">
						<span v-if="data.info.orders" class="badge">{{ data.info.orders }}</span>
					</span>
				</router-link>
			</div>

			<div v-if="canPirnt()" class="btn-group">
				<button @click="doPrint()" data-toggle="dropdown" class="btn btn-lg btn-default" type="button">
					<i class="fa fa-print" aria-hidden="true"></i>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data'],
		data () {
			return {
				loading: false,
			}
		},
		created () {
			//this.init()
		},
		methods: {
			init() {
				//
			},
			addBudget() {
				var that = this
				swal.queue([{
						title: this.$t("messages.attention"),
						text: this.$t("messages.budget_will_be_created"),
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							that.loading = true
							return new Promise(function (resolve) {
								that.$http.post('admin/customers/' + that.data.id + '/add/budget')
								.then(response => {
									that.loading = false
									that.$emit('reload')
									that.editOrContinue(response)
								}).catch(function(response) {
									that.loading = false
									console.log(response)
								})
							})
						}
					}]).catch(swal.noop)
			},
			editOrContinue(response) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
				}).catch(swal.noop)
			},
			goTo(to) {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						var to = '/' + this.$i18n.locale + '/admin/customers/' + this.data.id + '/' + to
					} else {
						var to = '/' + this.$i18n.locale + '/admin/' + menu + '/customers/' + this.data.id + '/' + to
					}
				} else {
					var to = '/' + this.$i18n.locale + '/admin/customers/' + this.data.id + '/' + to
				}

				return to
			},
			doPrint() {
				$(".printableArea").printThis()
			},
			canPirnt() {
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.name) {
							if(this.$route.meta.name == 'show') {
								return true
							}
						}
					}
				}

				return false
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/providers/views/Buttons.vue